import { useEffect } from "react";

/**
 * TallyPopup — Injects Tally.so popup form widget at runtime.
 * Mounted once in LandingPage. Sets window.TallyConfig + loads embed.js.
 */
export default function TallyPopup({
  formId = "gDOeZP",
  scrollPercent = 60,
  alignLeft = true,
  autoClose = 2000,
  emojiText = "👋",
  emojiAnimation = "wave",
  hideTitle = true,
  doNotShowAfterSubmit = true,
} = {}) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Set Tally config BEFORE the embed.js loads
    window.TallyConfig = {
      formId,
      popup: {
        emoji: { text: emojiText, animation: emojiAnimation },
        hideTitle,
        open: { trigger: "scroll", scrollPercent },
        alignLeft,
        autoClose,
        doNotShowAfterSubmit,
      },
    };

    // Avoid double-inject (e.g. hot-reload)
    if (document.querySelector('script[data-tally-embed]')) {
      // Re-init via global API if available
      if (typeof window.Tally?.loadEmbeds === "function") {
        try { window.Tally.loadEmbeds(); } catch (_) { /* noop */ }
      }
      return;
    }

    const script = document.createElement("script");
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    script.setAttribute("data-tally-embed", "true");
    script.onload = () => {
      if (typeof window.Tally?.loadEmbeds === "function") {
        try { window.Tally.loadEmbeds(); } catch (_) { /* noop */ }
      }
    };
    document.body.appendChild(script);

    // No cleanup — popup intended to live for the session
  }, [formId, scrollPercent, alignLeft, autoClose, emojiText, emojiAnimation, hideTitle, doNotShowAfterSubmit]);

  return null;
}
